module.exports = __webpack_public_path__ + "static/media/Machaut_Mix2.b76a460e.mp3";